"use strict";

const DOWNLOAD_TEMPLATE = `
    <div class="modal-content">
        <div id="btn-close-modal" class="close-downloadModal">
            <i class="fa fa-times-circle-o fa-5x pull-right"></i>
        </div>

        <div class="formats-container d-flex justify-content-center">
            <% for (var j = 0; j < this.formats.length; j++) { %>
                <% if (!_.isEmpty(this.model.get(this.formats[j]))) { %>
                    <% if (this.selectedFormat == this.formats[j]) { %>
                        <i class="<%= this.loadIcon(this.formats[j]) %> active hvr-push" aria-hidden="true" data-format="<%= this.formats[j] %>"></i>
                    <% } else { %>
                        <i class="<%= this.loadIcon(this.formats[j]) %> hvr-push" aria-hidden="true" data-format="<%= this.formats[j] %>"></i>
                    <% } %>
                <% } %>
            <% } %>
        </div>

        <div class="languages-container d-flex justify-content-center">
            <% for (var j = 0; j < this.formats.length; j++) { %>
                <% if (!_.objIsEmpty(this.model.get(this.formats[j]))) { %>
                    <div class="<%= this.formats[j] %>-container 
                    	<% if (this.selectedFormat == this.formats[j]) { %> d-flex <% } else { %> d-none <% } %>">
                        <% for (var i = 0; i < this.model.get(this.formats[j]).length; i++) { %>
                            <a href="<%= this.getUrl(this.model.get(this.formats[j])[i].url) %>" class="btn active hvr-push" target="_blank">
                                <%= app.localeManager.get("languages." + this.model.get(this.formats[j])[i].name.toLowerCase()) %>
                            </a>
                        <% } %>
                    </div>
                <% } %>
            <% } %>
        </div>

    </div>
`;

const BookDownloadModalComponent = Backbone.View.extend({

    className: "p40 downloadModal-off",

    // The available formats for download
	formats: ["pdf", "html", "audiobook"],

    id: "download-modal",

    // The currently selected format (default is PDF)
	selectedFormat: "pdf",

    $trigger: null,
    
    template: _.template( DOWNLOAD_TEMPLATE ),

    initialize: function(options) {
        this.options = options || {};
        // If a book does not have a pdf, then the initial state will be empty
        // We want to avoid that scenario by fetching the default format of the model
        this.selectedFormat = this.model.getDefaultFormat();
        this.listen();
    },

    // CSS operations AFTER the view closes
    afterClose: function() {
        this.$el.css({ opacity: "0", zIndex: "-9999" });
        // Remove this modal from the DOM
        // This element cannot have a duplicate on the page
        // Otherwise it will create conflicts
        $(document.body).find("#" + this.id).remove();
        
        // Ideally the app should listen for changes here instead
        app.resume();
    },

    // CSS operations BEFORE the view opens
    afterOpen: function() {
        this.$animatedElements.show();
        new TimelineMax().staggerFrom(this.$animatedElements , 0.6, { y: 30, opacity: 0, ease:Power2.easeOut }, 0.1);
    },

    // CSS operations BEFORE the view closes
    beforeClose: function(){
        $("main").css({ filter: "blur(0px)", transform: "scale(1)" });
    },

    // CSS operations BEFORE the view opens
    beforeOpen: function() {
        $("main").css({ filter: "blur(3px)", transform: "scale(0.9)" });
        this.$animatedElements.hide();
    },

    // Close the download dialog box
	close: function(e) {   
		e.preventDefault();
        // We want to delete any existing download modal before creating a new one
        var $el = this.$el;
        this.beforeClose();
        
        $el.removeClass("downloadModal-on")
            .addClass("downloadModal-off")
            .removeClass("bounceInUp")
            .addClass("bounceOutDown")
            .one("animationend", () => {
                this.afterClose();
            });
    },

    events: {
        "click .formats-container i": "updateLanguage",
		"click #btn-close-modal"    : "close",
    },
    // Return the URL of a book
	getUrl: function(link) {
        // If the link is a pdf return the link with the pdf directory
		if (/.pdf$/.test(link)) {
			// If the current directory is for the french version return the link to an upper level
			return "./assets/pdf/" + link;
		} else if (/\.audio\./g.test(link)) {
			// If the current directory is for the french version return the link to an upper level
			return "./assets/audio/" + link;
        }
		// If the link is an external html page return the link
		else if (/.html$/.test(link)) {
			return link;
		}
		return link;
	},
    
    listen: function() {
        // This view can accept a single dom element or a query selector as the trigger
        var tr = typeof(this.options.trigger === "string") ?
                    $(this.options.trigger) :
                    this.options.trigger;

        tr.on("click", () => {
            this.open();
            // Ideally, the app should call freeze itself
            // TODO: this component should not know anything about the app
            app.freeze();
        });
        
        // Listens to property changes on this object
        this.proxy = new Proxy(this, this.watcher);
    },

    // Loads the appropriate icon for the give format (pdf, html or audiobook)
	loadIcon: function(attr) {
		switch (attr) {
			case "audiobook":
				return "fa fa-headphones fa-4x";
			case "pdf":
				return "fa fa-book fa-4x";
			case "html":
				return "fa fa-external-link fa-4x";
			default:
				return "";
		}
    },

    open: function() {
        app.freeze();
        
		this.$el.addClass("animated")
            .removeClass("bounceOutDown")
            .removeClass("downloadModal-off")
            .addClass("downloadModal-on");

        this.beforeOpen();
        
        this.$el.css({ opacity: "1", zIndex: "9999" })
            .addClass("bounceInUp")
            .one("animationend", () => {
                this.afterOpen();
            });
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$animatedElements = this.$el.find("div");
        return this;
    },

    // Used outside of this view when another component wants to directly open the audiobook selection
    selectAudiobook: function() {
        this.proxy.selectedFormat = "audiobook";
    },

    updateLanguage: function(e) {
		// Change the selected reading format
		this.proxy.selectedFormat = $(e.target).attr("data-format");
    },

    watcher: {
        set: function(target, prop, newValue) {
            if (prop === "selectedFormat") {
                target.selectedFormat = newValue;
                target.render();

                return true;
            }

            return false;
        }
    },

});